<div class="save-footer layout-row layout-align-start-center">

  <bringoz-button (onClick)="onCancel.emit();$event.stopPropagation();"
                  type="tertiary">
    <span class="br-body-2 font-weight-400" translate>Cancel</span>
  </bringoz-button>

  <span class="flex"></span>

  <bringoz-button theme="secondary"
                  (onClick)="onSave.emit();$event.stopPropagation();">
    <bringoz-icon iconName="save" class="margin-right-5"></bringoz-icon>
    <span class="br-body-2 font-weight-400" translate>Save</span>
  </bringoz-button>
</div>
